import {NgModule} from '@angular/core';

import {ChartModule} from 'primeng/chart';
import {TableModule} from 'primeng/table';
import {TagModule} from 'primeng/tag';
import {InputSwitchModule} from 'primeng/inputswitch';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {MenuModule} from 'primeng/menu';
import {ToastModule} from 'primeng/toast';
import {DropdownModule} from 'primeng/dropdown';
import {MultiSelectModule} from 'primeng/multiselect';
import {AutoCompleteModule} from 'primeng/autocomplete'
import {TooltipModule} from 'primeng/tooltip';
import {RadioButtonModule} from 'primeng/radiobutton';
import { AvatarModule } from 'primeng/avatar';



@NgModule({
  exports: [
    AvatarModule,
    TableModule,
    TagModule,
    InputSwitchModule,
    InputTextModule,
    ButtonModule,
    MenuModule,
    ToastModule,
    DropdownModule,
    ChartModule,
    MultiSelectModule,
    AutoCompleteModule,
    TooltipModule,
    RadioButtonModule
  ],
  imports: []
})
export class PrimengModule {
}

